import { isomorphicCookies } from 'shared/storage'

import { type getSessionStoneAccounts } from '../services/get-session-stone-accounts'

type StoneAccount = Awaited<ReturnType<typeof getSessionStoneAccounts>>['stoneAccounts'][number]

const hasActiveResource = (stoneAccount: StoneAccount): boolean =>
  Boolean(stoneAccount.paymentAccount) || Boolean(stoneAccount.paymentProfiles?.length)

export const selectStoneAccount = (stoneAccounts: StoneAccount[]): StoneAccount | undefined => {
  const { identityId, defaultIdentity } = isomorphicCookies.getAll()

  return (
    stoneAccounts.find(stoneAccount => stoneAccount.legacy.globalId === identityId) ||
    stoneAccounts.find(stoneAccount => stoneAccount.legacy.globalId === defaultIdentity) ||
    stoneAccounts.find(hasActiveResource) ||
    stoneAccounts.find(stoneAccount => stoneAccount?.kyc?.status === 'approved') ||
    stoneAccounts.find(stoneAccount => stoneAccount?.approvalStatus === 'limited') ||
    stoneAccounts[0]
  )
}
